import { cn } from "@/lib/utils";
import { FilterCombobox } from "../../FilterCombobox";
import { Label } from "@/components/ui/label";
import { FileFailureType, FileFailureTypeColors, FileFailureTypeIcons, FileFailureTypeLabels } from "../../../../models/FileFailureType";
import { filterComboboxClassName } from "../TableStyles";

interface FileFailureTypeFilterProps {
  value: string | null;
  onChange: (newValue: string | null) => void;
  className?: string;
}

export const FileFailureTypeFilter = ({
  value,
  onChange,
  className,
}: FileFailureTypeFilterProps) => (
  <div className={cn(filterComboboxClassName, className)}>
    <Label className="text-xs font-semibold text-muted-foreground">Failure reason</Label>
    <FilterCombobox
      value={value}
      onChange={onChange}
      placeholder="Failure reason"
      options={Object.values(FileFailureType)
        .filter((failureType) => ![FileFailureType.None].includes(failureType as FileFailureType))
        .map((failureType) => ({
          value: failureType,
          label: FileFailureTypeLabels[failureType as FileFailureType],
          color: FileFailureTypeColors[failureType as FileFailureType],
          icon: FileFailureTypeIcons[failureType as FileFailureType],
        }))}
    />
  </div>
);
